<template>
    <div>
        <div class="fileupload-buttons d-flex align-items-center">
            <label class="file-select mb-0">
                <input class="file-input"  type="file" :accept="acceptedFiles" @change="handleFileChange"/>
                <btn class="select-btn" icon="upload" label="Upload File"/>
            </label>
            <template v-if="showAlternative">
                <span class="mx-2"> or </span>
                <btn theme="secondary" icon="link" label="Enter URL" @click="$emit('urlClick', $event)"/>
            </template>
        </div>

        <div class="alert alert-danger mt-2" v-if="validationError.size || validationError.type">
            <div v-if="validationError.size"> Your file exceeds the size limit</div>
            <div v-if="validationError.type"> Your file type does not fit the allowed types ({{ formatAllowedFiles }})</div>
        </div>

        <ul class="mt-3 file-upload-rules">
            <li v-if="maxImageSize !== null">Allowed formats are {{ formatAllowedFiles }}</li>
            <li>File size is limited to {{ parseInt(maxImageSize / (1024*1024)) }} MB for images and {{ parseInt(maxPdfSize / (1024*1024)) }} MB for PDFs</li>
            <li v-if="showAlternative">You can host larger images yourself and provide an URL</li>
        </ul>
    </div>
</template>

<style lang="scss">
    .file-select {
        cursor: pointer;

        .file-input {
            display: none;
        }

        .select-btn {
            pointer-events: none;
        }

    }
    .file-upload-rules {
        padding-left: 25px;
    }
</style>

<script>
    export default {
        props: {
            maxImageSize: {type: Number, default: 2*1024*1024}, //2MB
            maxPdfSize: {type: Number, default: 50*1024*1024}, //50MB
            acceptedFiles: {type: Array, required: true},
            showAlternative: {type: Boolean, default: false},
        },

        data() {
            return {
                validationError: {
                    size: false,
                    type: false,
                },
            };
        },

        computed: {
            // show ['.ext1, '.ext2', '.ext3'] as string 'EXT1, EXT2 and EXT3'
            formatAllowedFiles() {
                return this.acceptedFiles
                    .map(ext => ext.slice(1).toUpperCase()) // remove dot and make all uppercase
                    // special case for jpeg/jpg: allow both, but show only one
                    .filter((ext, i, arr) => ['JPG', 'JPEG'].every(val => arr.includes(val)) ? ext !== 'JPG' : true)
                    .reduce((acc, curr, i, arr) => {
                        if (i === 0) {
                            return curr;
                        }
                        let divider = i === arr.length - 1 ? ' and ' : ', ';
                        return `${acc}${divider}${curr}`;
                    }, '');
            },
        },

        methods: {
            handleFileChange({target}) {
                let [file] = target.files;
                let validated = this.validateFile(file);
                if (!validated) {
                    return;
                }
                this.$emit('fileValidated', file);
            },

            validateFile({type, size}) {
                let validated = false;
                if (!type || !size) {
                    return validated;
                }
                let regexString = this.acceptedFiles
                    .map(ext => ext.slice(1).toLowerCase())
                    .reduce((acc, curr, i) => i < this.acceptedFiles.length -1 ? acc + `\\b${curr}|` : acc +`\\b${curr})`, '(');
                let regexp = new RegExp(regexString, 'g');
                let correctType = regexp.test(type);
                let correctSize = /pdf/.test(type) ? size <= this.maxPdfSize : size <= this.maxImageSize;

                if (correctType && correctSize) {
                    validated = true;
                    this.validationError.type = false;
                    this.validationError.size = false;
                } else {
                    if (!correctType) {
                        this.validationError.type = true;
                    }
                    if (!correctSize) {
                        this.validationError.size = true;
                    }
                }

                return validated;
            },
        },
    };
</script>